import { defineComponent } from "vue";
import zhCn from "element-plus/es/locale/lang/zh-cn";
export default defineComponent({
  setup() {
    const debounce = (fn, delay) => {
      let timer = null;
      return () => {
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(null, args);
        }, delay);
      };
    };
    const _ResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
      constructor(callback) {
        callback = debounce(callback, 16);
        super(callback);
      }
    };
    return {
      locale: zhCn
    };
  }
});